<template>
    <v-dialog v-model="editorShownVacation" width="850">
        <!-- Begin:Content:Mode:update ------------------------------------- -->
        <v-card v-if="editorMode === 'update'" style="border: 2px solid gray;">
            <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: gray;" class="b-fa b-fa-umbrella-beach"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Vacation - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Vacation  - to" disabled="true" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <request-status-combo v-model="requeststatus" label="Select - Request Status:" />
                    </v-col>
                </v-row>
            </v-card-text>


            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Vacation Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownVacation = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_VacationUpdate"> Save</v-btn>
            </v-card-actions>
        </v-card>



        <!-- Begin:Content:Mode:create ------------------------------------- -->
        <v-card v-if="editorMode === 'create'" style="border: 2px solid gray;">
            <v-card-title class="grey lighten pa-5" style="color: white; font-size: 15px; font-weight: 500;">
                <i style="font-size:20px; color: gray;" class="b-fa b-fa-umbrella-beach"></i>&nbsp;&nbsp;{{ this.eventName || '&nbsp;' }} ({{ editorMode.toUpperCase() }})
            </v-card-title>

            <v-card-text class="pa-5">
                <datetime v-model="startDate" label="Vacation - from" disabled="false" disabledTime="true" ref="startTimer" />
                <datetime v-model="endDate" label="Vacation  - to" disabled="false" disabledTime="true" ref="endTimer" />

                <v-row>
                    <v-col cols="6" class="">
                        <request-status-combo v-model="requeststatus" label="Select - Request Status:" />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="pa-5">
                <comment-textarea v-model="dutyComment" label="Vacation Comment:" maxlength="300" />
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="editorShownVacation = false">Cancel</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onSave_VacationCreate"> Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import CommentTextarea from '../../CommentTextarea.vue';
    import RequestStatusCombo from '../../RequestStatusCombo.vue';

    import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import moment from 'moment';


    export default {
        name  : 'event-editor-vacation',

        /* >>> *************************************************************** / /* Props */
        props : {

            value           : [ Boolean, Object ],                              // editorShownVacation
            eventStore      : Object,                                           // 'update'
            resourceId      : [ String, Number ],                               // 'update'
            eventRecord     : Object,                                           // 'update'
            resourceRecord  : Object,                                           // 'create'
            addDate         : Date,                                             // 'create'
            eventName       : String,                                           // 'update', 'create'
            editorMode      : String,                                           // 'update', 'create'

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,
            CommentTextarea,
            RequestStatusCombo,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: () => ({

            // >>> ------------------------------
            startDate       : null,
            endDate         : null,
            // >>> ------------------------------
            requeststatus   : null,
            // >>> ------------------------------
            dutyComment     : null,

        }), // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_shared_IsEditingInThePastAllowed',
            ]),


            editorShownVacation: {

                /***************************************************************
                * get()
                *
                * Desc:
                * Note:
                */
                get() {

                    let me = this,
                        timestamp = null,
                        startDate = null,
                        endDate = null,
                        resourceRecord = me.resourceRecord,
                        eventRecord = me.eventRecord;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/vacation/EventEditor.vue >>> editorShownVacation get');
                    if (true === me.value) {                                    // we're opening so initialize data

                        // >>> ------------------ update
                        if (this.editorMode === 'update') {
                            if (eventRecord) {
                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : new Date(eventRecord.startDate),
                                    endDate         : new Date(eventRecord.endDate),
                                    dutyComment     : eventRecord.dutyComment,
                                    requeststatus   : eventRecord.requestStatus,
                                });
                            }
                        }

                        // >>> ------------------ create
                        if (this.editorMode === 'create') {
                            if (resourceRecord) {
                                timestamp = new Date(this.addDate).setHours(0, 0, 0, 0);
                                startDate = new Date(timestamp);
                                timestamp = new Date(this.addDate).setHours(23, 59, 0, 0);
                                endDate = new Date(timestamp);

                                Object.assign(me, {
                                    eventName       : this.eventName,
                                    startDate       : startDate,
                                    endDate         : endDate,
                                    dutyComment     : null,
                                    requeststatus   : null,
                                });
                            }
                        }

                    } else if (false === me.value) {                            // we're closing so fire close event
                        // this.$emit('close'); // Needed?
                    }

                    // return always Boolean
                    return !!this.value;

                }, // eo editorShownVacation get

                /***************************************************************
                * set()
                *
                * Desc:
                * Note: only runs on close.
                */
                set(value) {

                    let me = this;;


                    me.$toc('>>> views/crewplanning/crewcalendar/components/editevents/vacation/EventEditor.vue >>> editorShownVacation set');
                    this.$emit('input', value);

                } // eo editorShownVacation set

            } // eo editorShownVacation

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Listen to: 'updatevacation'.
        * Note: Runs after the instance is created. Installs Listeners.
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> created');
            eventBus.$on('updatevacation', this.onUpdate_SingleDuty); // call: update single duty successful
            eventBus.$on('onchangedatepicker', this.onChange_DatePicker); // onChange_DatePicker

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> beforeDestroy');
            eventBus.$off('updatevacation', this.onUpdate_SingleDuty);
            eventBus.$off('onchangedatepicker', this.onChange_DatePicker);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_update_SingleDuty', // Call: Modify Single Duty
                'actn_create_SingleDuty', // Call: Create Single Duty
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSave_VacationUpdate()
            *
            * Desc: Save Handler - 'UPDATE'.
            * Note: Tooltip is in 'note'.
            * Note: Calling this method updates also duration (resizes the event)
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_VacationUpdate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> onSave_VacationUpdate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : me.eventRecord.originalId,
                    idResource      : me.resourceId,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'VACATION',
                    status          : 'PLANNED',
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null,
                    requestStatus   : this.requeststatus !== null ? this.requeststatus.toUpperCase() : null, // #611
                };

                this.actn_update_SingleDuty(params);

            }, // eo function onSave_VacationUpdate()


            /*******************************************************************
            * onSave_VacationCreate()
            *
            * Desc: Save Handler - 'CREATE'.
            * Note: Tooltip is in 'note'.
            * Note: Check if edit in past is allowed.
            *
            */
            onSave_VacationCreate: function() {

                let me = this,
                    params = {};


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> onSave_VacationCreate');
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: [me.startDate], isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                params = {
                    id              : null,
                    idResource      : this.resourceRecord.id,
                    from            : moment(me.startDate).format('YYYY-MM-DDT05:00:ss+0000'),
                    to              : moment(me.endDate).format('YYYY-MM-DDT21:00:ss+0000'),
                    type            : 'VACATION',
                    status          : 'PLANNED',
                    split           : true,
                    dutyComment     : me.dutyComment !== '' ? me.dutyComment : null,
                    requestStatus   : this.requeststatus !== null ? this.requeststatus.toUpperCase() : null, // #611
                };

                if (this.validateParams(params) === true) {
                    this.actn_create_SingleDuty(params);
                }

            }, // eo function onSave_VacationCreate()



            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onUpdate_SingleDuty()
            *
            * Desc: Successful Call => emits 'modifysingleduty' Event.
            * Desc: Change Data in Scheduler.
            * Note: Using Response of call:actn_update_SingleDuty for buildEventNote
            *
            * @param {Object} response (Response from Call)
            */
            onUpdate_SingleDuty: function(response) {

                let me = this,
                    style = '',
                    tooltiptData = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> onUpdate_SingleDuty');
                me.eventRecord.setStartEndDate(me.startDate, me.endDate);
                // me.eventRecord.set({ requested: me.requested });
                // me.eventRecord.set({ remainingDayOff: me.remainingDayOff });
                me.eventRecord.set({ dutyComment: me.dutyComment });
                me.eventRecord.set({ requestStatus: me.requeststatus }); // #611

                tooltiptData = me.$buildEventNote(response); // Catch after 'requested was set!: Important
                me.eventRecord.set({ nameEvent: tooltiptData.nameEvent });
                me.eventRecord.set({ note: tooltiptData.note });

                // >>> Style ----------------------------------------
                if (me.requeststatus !== null) {
                    style += me.requeststatus === 'REQUESTED' || me.requeststatus === 'MAINREQUEST' || me.requeststatus === 'SECONDARYREQUEST' || me.requeststatus === 'REPLACEMENTREQUEST' ? 'background: repeating-linear-gradient(45deg, #ececec,#ececec 10px,#ccc 10px,#ccc 20px);' : '';
                }
                if (response.dutyComment !== null) {
                    style += ' border-right: 3px dotted #000;';
                }
                me.eventRecord.set({ style: style });
                // <<< Style ----------------------------------------

                if (!me.eventRecord.eventStore) {
                    me.eventStore.add(me.eventRecord);
                    me.eventRecord.resourceId = me.resourceId;
                }

                // >>> close the editor now ...
                me.editorShownVacation = false;

            }, // eo function onUpdate_SingleDuty()


            /*******************************************************************
            * onChange_DatePicker()
            *
            * Desc: If Start DatePicker changed, it emits an Event and its
            * Desc: new Value to set it to End DatePicker.
            * Note: Do nothing here. Dont set END like START Date (like in DAYOFF).
            *
            * @param {String} value ()
            */
            onChange_DatePicker: function(value){

                let me = this,
                    newDate = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> onChange_DatePicker');
                newDate = new Date(value);
                newDate.setHours(23);
                newDate.setMinutes(59);
                me.endDate = newDate;

            }, // eo function onChange_DatePicker()




            /*******************************************************************
            * Validators:
            *******************************************************************/
            /*******************************************************************
            * validateParams()
            *
            * Desc:
            * Note:
            *
            * @param {Object} params (Params we want to send)
            */
            validateParams: function(params) {

                let me = this,
                    startDate = null,
                    endDate = null,
                    valid = false;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/editevents/vacation/EventEditor.vue >>> validateParams');
                startDate = moment(params.from);
                endDate = moment(params.to);

                if (endDate.isBefore(startDate)) {
                    valid = false;
                    Vue.prototype.$toasted.global.sdr_app_error({
                        message: 'Validation: EndDate must be after StartDate.'
                    });
                } else {
                    valid = true;
                }


                return valid;

            }, // eo function validateParams()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>
